import { ChangeEvent } from "react";
import { Col, Form, FormGroup, Input, Label } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { AgreeConditions, Finish } from "../../../../Constant";
import { useAppDispatch, useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { NetBankingAccordion } from "./NetBankingAccordion";
import { bankingNextHandler, setNetBankingForm } from "../../../../Redux-Toolkit/Reducers/FormLayout/VerticalWizardSlice";

const NetBankingForm = () => {
  const { netBankingFormValues } = useAppSelector((state) => state.verticalWizard);
  const dispatch = useAppDispatch();
  const { feedBack } = netBankingFormValues;

  const getUserData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const value = event.target.value;
    dispatch(setNetBankingForm({ ...netBankingFormValues, [name]: value }));
  };

  return (
    <Form onSubmit={(event) => event.preventDefault()} className="row g-3 mb-3 needs-validation" noValidate>
      <Col md="12">
        <NetBankingAccordion netBankingFormValues={netBankingFormValues} getUserData={getUserData} />
      </Col>
      <Col xs="12">
        <Input type="textarea" name="feedBack" value={feedBack} onChange={getUserData} placeholder="Your Feedback" />
      </Col>
      <Col xs="12">
        <FormGroup className="mb-0" check>
          <Input id="invalidCheck67" type="checkbox" required />
          <Label className="mb-0" htmlFor="invalidCheck67" check>{AgreeConditions}</Label>
        </FormGroup>
      </Col>
      <Col xs="12" className="text-end">
        <Btn color="success" onClick={() => dispatch(bankingNextHandler())}>{Finish}</Btn>
      </Col>
    </Form>
  );
};

export default NetBankingForm;
